/// <reference types="jquery" />
/// <reference types="q" />

import TFS_Dashboards_Resources = require("Dashboards/Scripts/Resources/TFS.Resources.Dashboards");
import Context = require("VSS/Context");
import Service = require("VSS/Service");
import Utils_String = require("VSS/Utils/String");

import { AnalyticsHttpClient } from "Analytics/Common/RestClient";
import { AnalyticsState } from "Analytics/Common/Contracts";
import { LocationService } from "VSS/Navigation/Location";
import { getLocalService } from "VSS/Service";

export const ExtensionDisabledDialogClass = "extension-disabled-widget";
export const AnalyticsNotEnabledStringFormat = "<p>{0}<a href=\"{1}\">{2}</a>{3}</p>"

export class AnalyticsDisabledHandler {

    public static isAnalyticsEnabledAsync(): IPromise<boolean> {
        if (Context.getPageContext().webAccessConfiguration.isHosted) {
            return Promise.resolve(true);
        } else {
            return Service.getClient(AnalyticsHttpClient).getState().then((state)=>{
                return state.analyticsState === AnalyticsState.Enabled;
            });
            
        }
    }

    public static isContributionIsAnalyticsBased(contributionId: string): boolean {
        return (AnalyticsDisabledHandler.analyticsContributionIds.indexOf(contributionId) > -1);
    }

    public static getAnalyticsDisabledDialogOptions(): any {
        const analyticsManagementPageUrl = getLocalService(LocationService).routeUrl("ms.vss-analytics.analytics-management-route", {});  

        return {
            title: TFS_Dashboards_Resources.AnalyticsNotEnabled_DialogHeading,
            contentText: Utils_String.format(AnalyticsNotEnabledStringFormat,
                TFS_Dashboards_Resources.AnalyticsNotEnabled_DialogContentTextFirstPart,
                analyticsManagementPageUrl,
                TFS_Dashboards_Resources.AnalyticsNotEnabled_SettingsPageLinkText,
                TFS_Dashboards_Resources.AnalyticsNotEnabled_DialogContentTextLastPart),
            cssClass: ExtensionDisabledDialogClass,
            isRichText: true
        }
    }

    private static analyticsContributionIds: Array<string> = [
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.BurndownWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.BurnupWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.CumulativeFlowDiagramWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.CycleTimeWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.LeadTimeWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.VelocityWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.MonteCarloWidget",
        "ms.vss-test-web.Microsoft.VisualStudioTeamServices.TestManagement.AnalyticsTestTrendWidget"
    ];
}